import { GAP_LABEL } from '../../constants/exclusions.js';

export function GapTypeChips({ gapTypes, selected, onToggle }) {
  if (!gapTypes) return null;
  const entries = Object.entries(gapTypes).filter(([, n]) => n > 0);
  if (entries.length === 0) return null;
  entries.sort(([, a], [, b]) => b - a);

  return (
    <div
      style={{
        display: 'flex', gap: 6, marginBottom: 12,
        flexWrap: 'wrap', alignItems: 'center',
      }}
    >
      <span style={{ fontSize: 11, color: '#666', marginRight: 4 }}>Gap type:</span>
      {entries.map(([g, n]) => {
        const active = selected.has(g);
        return (
          <button
            key={g}
            onClick={() => onToggle(g)}
            style={{
              padding: '4px 10px', fontSize: 11, fontWeight: 600, cursor: 'pointer',
              border: active ? '1px solid #002159' : '1px solid #dee2e6',
              background: active ? '#002159' : '#fff',
              color: active ? '#fff' : '#555',
              borderRadius: 12,
            }}
          >
            {(GAP_LABEL[g] || g)} ({n.toLocaleString()})
          </button>
        );
      })}
    </div>
  );
}
